const removeFocusedTag = ({ state, props, path }) => {
  const tags = state.get(`selectr.${props.namespace}.selected`)
  const focusedTag = props.focusedTag
  const tag = tags[focusedTag]
  state.push(`selectr.${props.namespace}.options`, {
    label: tag.label
  })

  state.splice(`selectr.${props.namespace}.selected`, focusedTag, 1)
  return { value: tag.label }
}

removeFocusedTag.displayName = 'removeFocusedTag'
export default removeFocusedTag
